import React, {ReactNode, FC, RefObject, useRef } from 'react';
import { ToggleSectionContainer } from './ToggleSection.elements';
import { ChevronRight } from 'icons/indexed-icons/ChevronRight';

export interface ToggleSectionBaseProps {
  /** is the open/close disabled */
  disabled?: true,
  /** gets added as data-drag-id */
  dragId?: string,
  handleOpen?: (x?: boolean, e?: React.SyntheticEvent) => void,
  /** incoming function to get status of section */
  checkIfOpen?: (x: boolean) => boolean | void,
  /** title area */
  title?: ReactNode,
  /** custom icon left of title */
  children?: ReactNode,
  /** custom right icon */
  IconRight?: (x?: Record<string, unknown>) => JSX.Element,
}
export interface ToggleSectionProps extends ToggleSectionBaseProps {
  
  /** if you don't want to use children you can send Component */
  Component?: (x?: Record<string, unknown>) => JSX.Element,
  /** gets added as data-id */
  dataId?: string,
  Icon?: FC,
  /** start open if true */
  isOpen?: boolean,
  /** add custom class */
  className?: string,
  styleType?: 'chart-wrapper' | string,
  /** incoming section ref */
  sectionRef?: RefObject<HTMLDetailsElement>,
  Components?: {
    Summary?: FC<Record<string, unknown>>,
    Section?:FC<Record<string, unknown>>,
  },
  dataAttr?: {
    [key: string]: string | boolean | undefined
  },
  ref?: RefObject<HTMLDetailsElement>,
}
export const ToggleSection = ({ checkIfOpen, dataId, disabled, dragId, Components, children, Component, title, Icon, isOpen, className, styleType, sectionRef, handleOpen, IconRight, dataAttr, ref }: ToggleSectionProps): JSX.Element => {
  
  const detailsRef = sectionRef || useRef(null)

  const { Summary, Section } = Components || {}

  className = `toggle-section ${className || ''}`.trim()
  
  if (styleType === 'chart-wrapper') className += ' chart-wrapper'
  if (disabled) className += ' is-disabled'
  if (isOpen) className += ' is-open'
  
  Icon = (Icon || ChevronRight) as FC

  const TitleToUse = () => styleType === 'chart-wrapper' 
      ? <h2 className='toggle-section-title'>{title}</h2> 
      : <h3 className='toggle-section-title'>{title}</h3>
   
 
 
  const togglerSettings = {
    open: isOpen ? true : undefined,
    className,
    ref: detailsRef,
    draggable: dragId ? true : undefined,
    'data-order-id': dragId || undefined,
    'data-id': dataId || undefined,
    onToggle: (e: React.SyntheticEvent<HTMLDetailsElement>) => {
      const open = (e.target as HTMLDetailsElement).open
      checkIfOpen?.(open)
      handleOpen?.(open, e)
    }
  }
 
  return (
    <ToggleSectionContainer {...dataAttr} {...togglerSettings} ref={ref}>
      {Summary 
        ? <Summary {...{ className: 'toggler', Icon: <Icon data-id='toggle-icon' /> }} />
        : <summary><Icon data-id='toggle-icon' /><TitleToUse />{IconRight && <IconRight />}</summary>}
      
      {Section
        ? <Section {...togglerSettings}>{children}</Section>
        : Component ? <Component /> : <section>{children}</section>}

    </ToggleSectionContainer>
  )
}